module.exports = {
  name: "Super User",
  username: "superuser",
  password: "234",
  privillages: [
    "Customers",
    "Add New Customers",
    "View Transactions",
    "View Orders",
    "Update Customer",
    "Payment",
    "Dashboard",
    "Employees",
    "Add New Employees",
    "Give User",
    "Delete Employee",
    "Update Employee",
    "Adminstration",
    "Users",
    "Access",
    "Reset User",
    "Delete User",
    "Company Info",
   "Menus",
   "Add New Menus",
   "Delete Menu",
   "Update Menu",
   "View Menu",
   "Styles",
   "Add New Styles",
   "Update Styles",
   "Delete Styles",
   "Order Lists", "Assign Order", "Finish Order",
        "Take Order", "Cancel Order",
   "New Order",
   "Charge User",
   "Billing",
   "Disable User",
   "Add New Users",
   "View Customers",
   "Calculator",
   "Send Sms",
   "Speech",
   "Ogeysiis",
   "Users Report",
   "Game"
  ],
};

 